import { Easing } from "remotion";
import type { Easing as EasingName } from "@veyso/core";

/** Maps the timeline's easing names onto Remotion's easing functions. */
export function easingFor(name: EasingName): (input: number) => number {
  switch (name) {
    case "linear":
      return Easing.linear;
    case "ease-in":
      return Easing.in(Easing.cubic);
    case "ease-out":
      return Easing.out(Easing.cubic);
    case "ease":
    case "ease-in-out":
      return Easing.inOut(Easing.cubic);
    case "spring":
      // A cheap overshoot curve; genuine spring physics needs frame state that
      // an easing function does not get.
      return Easing.bezier(0.34, 1.56, 0.64, 1);
    default:
      return Easing.inOut(Easing.cubic);
  }
}
